import { useGetHttp } from "../../../../hooks/http/http.hook";

export interface ICampaignBrandMetricMinimal {
  totalCount: number;
  averageCommentsPerPost: number | null;
  averageLikesPerPost: number | null;
  averageSharesPerPost: number | null;
  averageViewsPerPost: number  | null;
  approvedPosts: number | null;
  totalPosts: number | null;
  rejectedPosts: number | null;
  totalViews: number | null;
  totalComments: number | null;
  totalLikes: number | null;
  totalShares: number | null;
  postsPerDay: Array<{ [date: string]: number }> | null;
  totalViewsChart: Array<{ [date: string]: number }> | null;
  lastUpdatedAt: Date | null;
}


interface IResponse {
  metrics: ICampaignBrandMetricMinimal;
}

export function useGetCampaignMetricsHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns/:id/metrics",
  });
}